import { render, staticRenderFns } from "./StaffReports.vue?vue&type=template&id=22b88f16&scoped=true&"
import script from "./StaffReports.vue?vue&type=script&lang=js&"
export * from "./StaffReports.vue?vue&type=script&lang=js&"
import style0 from "./StaffReports.vue?vue&type=style&index=0&id=22b88f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b88f16",
  null
  
)

export default component.exports